import { gql } from '@apollo/client'

export const GET_ALL_GROUPS_CATEGORIES = gql`
  query GetAllGroupsCategories(
    $limit: Int
    $offset: Int
    $searchQuery: String
  ) {
    getAllGroupsCategories(
      limit: $limit
      offset: $offset
      searchQuery: $searchQuery
    ) {
      count
      rows {
        id
        group_id
        name
        description
        icon
        order
        allow_create_in_app
        allow_create_in_web
        show_system
        icon_file_id
        GroupOfGroupsCategory {
          id
          name
        }
        GroupCategoryIconFile {
          id
          url
        }
      }
    }
  }
`

export const CREATE_GROUPS_CATEGORIES = gql`
  mutation CreateGroupsCategories($input: GrupsCategoriesInput!) {
    createGroupsCategories(input: $input) {
      id
      group_id
      name
      description
      icon
      order
      allow_create_in_web
      allow_create_in_app
      show_system
      icon_file_id
      GroupCategoryIconFile {
        id
        url
      }
      GroupOfGroupsCategory {
        id
        name
      }
    }
  }
`

export const UPDATE_GROUPS_CATEGORIES = gql`
  mutation UpdateGroupsCategories(
    $updateGroupsCategoriesId: Int!
    $input: GrupsCategoriesInput!
  ) {
    updateGroupsCategories(id: $updateGroupsCategoriesId, input: $input)
  }
`

export const DELETE_GROUPS_CATEGORIES = gql`
  mutation DeleteGroupsCategories($deleteGroupsCategoriesId: Int!) {
    deleteGroupsCategories(id: $deleteGroupsCategoriesId)
  }
`

export const GET_ONE_GROUPS_CATEGORIES = gql`
  query GetOneGroupsCategories($getOneGroupsCategoriesId: Int!) {
    getOneGroupsCategories(id: $getOneGroupsCategoriesId) {
      id
      group_id
      name
      description
      icon
      order
      allow_create_in_web
      allow_create_in_app
      show_system
      icon_file_id
      GroupOfGroupsCategory {
        id
        name
      }
      GroupCategoryIconFile {
        id
        url
      }
    }
  }
`
